var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Status da Campanha")]),_vm._v(" "),_c('table',{ref:"tabela",staticClass:"table display table-hover table-striped",staticStyle:{"width":"100%"},attrs:{"id":"relAnalitic"}},[_c('thead'),_vm._v(" "),_c('tbody'),_vm._v(" "),_c('tfoot')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }